module.exports = __webpack_public_path__ + "static/media/trust-seal.c7d24133.png";